/**
 * @generated SignedSource<<40c55fdc642a48dc1c0004d59d2f7e7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OutOfStoreListItem_moviment$data = {
  readonly name: string;
  readonly icon: {
    readonly id?: string | null;
  } | null;
  readonly " $fragmentType": "OutOfStoreListItem_moviment";
};
export type OutOfStoreListItem_moviment$key = {
  readonly " $data"?: OutOfStoreListItem_moviment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OutOfStoreListItem_moviment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutOfStoreListItem_moviment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "type": "AdminUiIcon",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociateTrackingMovementStep",
  "abstractKey": null
};

(node as any).hash = "cfbb5b0b4b316a8b11b6a0634b062054";

export default node;
